import { createRouter, createWebHistory } from 'vue-router'
import GoogleLogin from '../views/GoogleLogin'
import { useUserStore } from "../store/user";
import PartView from '../views/PartView'
import SearchView from '../views/SearchView'
import ModelView from '../views/ModelView'
import ASWOVestelSN from '../views/ASWOVestelSN'
import Signup from '../views/Signup'
const routes = [
  {
    path: '/',
    name: 'search',
    component: SearchView
  },
  {
    path: '/part/:id',
    name: 'Part',
    component: PartView,

  },

  {
    path: '/login',
    name: 'login',
    component: GoogleLogin
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },

  {
    path: '/models',
    name: 'models',
    component: ModelView,

  },
  {
    path: '/vestel',
    name: 'Vestel',
    component: ASWOVestelSN,

  }, {
    name: "Register",
    path: "/register",
    component: () => import("../views/Register"),
  },
  {
    name: "EmailConfirmation",
    path: "/email-confirmation",
    component: () => import("../views/EmailConfirmation.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {

  const publicPages = ['/login', '/vestel', '/signup', '/register', '/email-confirmation'];
  const authRequired = !publicPages.includes(to.path);
  const { user } = useUserStore();
  console.log(user);
  if (authRequired && !user) {

    return '/login';
  }
});

export default router
